/*
    Open Book
    by Quaternius (https://poly.pizza/m/FsCIGEfTEs)
    Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { type JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Book2_Open_1: Mesh
      Book2_Open_2: Mesh
      Book2_Open_3: Mesh
    }
    materials: {
      Beige: MeshStandardMaterial
      DarkRed: MeshStandardMaterial
      Golden: MeshStandardMaterial
    }
  }

export function Book(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/book.glb') as GLTFResult

  return (
    <group {...props} dispose={null}>
      <group position-y={0.08} rotation={[-Math.PI / 2, 0, 0]} scale={100}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Book2_Open_1.geometry}
          material={materials.Beige}
          material-color="white"
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Book2_Open_2.geometry}
          material={materials.DarkRed}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Book2_Open_3.geometry}
          material={materials.Golden}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/book.glb')
